import { FACEBOOK_MESSENGER_URL } from 'src/constants';
import { PageCategory } from 'src/lib/api';
import { MessageSchema } from '../types';

const namespace: MessageSchema = {
	pageNotFound: 'Page was not found',
	backToHomepage: 'Back to home screen',
	appVersion: 'App version',
	deleteAccount: 'Delete account',
	areYouSureYouWantToDeleteYourAccount:
		"Are you sure you want to delete your account? All your data will be deleted and you can't access it again!",
	delete: 'Delete',
	cancel: 'Cancel',
	[PageCategory.handbook]: 'ITS handbook',
	[PageCategory.recipes]: 'Recipes',
	[PageCategory.workoutProgram8Weeks]: 'Exercise program 8 weeks',
	[PageCategory.runningProgram8Weeks]: 'Running program 8 weeks',
	[PageCategory.workoutProgram8WeeksMaster]: 'Exercise program 8 weeks masters',
	[PageCategory.cooling]: 'Cooling',
	[PageCategory.breathing]: 'Breathing',
	login: 'Log in',
	measurements: 'Measurements',
	password: 'Password',
	email: 'Email',
	diaries: 'Registrations',
	missingEmail: 'Email is missing',
	missingPassword: 'Password is missing',
	contentIsComingSoon: 'Content is coming soon',
	greenStreakDescription: '',
	itsIndex: 'ITS index',
	loginFail: 'Log in failed',
	comment: 'Comment',
	changePhoto: 'Change photo',
	changeSaved: 'Change saved',
	changeSaveFailed: 'Unable to save changes',
	progress: 'Progress',
	home: 'Home',
	errorOccurred: 'Error occurred, please try again later',
	log: 'Log',
	uploadPhoto: 'Upload photo',
	takePhoto: 'Take photo',
	pickPhotoFromGallery: 'Pick from gallery',
	menu: 'Menu',
	logOut: 'Log out',
	yes: 'Yes',
	no: 'No',
	myFitnessPal: 'My Fitness Pal',
	resetPassword: 'Reset password',
	meditation: 'Meditation',
	nutritionTables: 'Nutrition Tables',
	miscellaneous: 'Miscellaneous',
	passwordConfirmation: 'Password Confirmation',
	essays: 'Essays',
	trendingProducts: 'Trending Products',
	macrosExperience: 'Experience with macros',
	video: 'Video',
	macrosStories: 'Macros Stories',
	tips: 'Tips',
	yoga: 'Yoga',
	articles: 'Articles',
	beginning: 'Beginning',
	myGoals: 'My goals',
	education: 'Education',
	messenger: 'Messenger',
	userInitialInfoOverview: 'My goals',
	height: 'Height',
	gender: 'Gender',
	code: 'Code',
	missingCode: 'Code is missing',
	passwordsDontMatch: "Passwords don't match",
	goal: 'Goal',
	name: 'Name',
	postalCode: 'Postal code',
	location_note: 'Residence',
	residence: 'Residence',
	noResults: 'No results',
	iLiveOutsideIceland: "I don't live in Iceland",
	birthdate: 'Birthdate',
	userPersonalGoalsPage: {
		ifYouWantToChangeYourPersonalGoalsContactUsViaMessenger: `If you want to change your goals, please let us know via <a href="${FACEBOOK_MESSENGER_URL}</a>`,
	},
	genderOptions: {
		male: 'Male',
		female: 'Female',
		other: 'Other',
	},
	personalGoals: {
		haveYouTriedMacrosBefore: 'Have you been with us before or tried macros?',
		haveYouTriedMacrosBeforePleaseTellUsMore:
			'Please tell us about it and what numbers you had and how it went',
		tellUsAboutYourself: 'Tell us about yourself!',
		whatIsYourGender: 'What is your gender?',
		whenWereYouBorn: 'When were you born?',
		whereDoYouLive: 'Where do you live?',
		whatIsYourWeight: 'What is your weight? (kg)',
		whatIsYourHeight: 'What is your height? (cm)',
		whatAreYourGoals: 'What are your goals?',
		exercisesEveryWeek: 'Exercises every week',
		exercisesEveryWeekSubtitle:
			'Describe quite accurately how you move your body every week',
		whatIsYourJob: 'What is your occupation?',
		foodTitle: 'Food',
		whatAppliesToYou: 'What applies to you?',
		situationTitle: 'Situation',
		yourStrengths: 'Your strengths',
		nameSomethingThatWouldBeFunToKnowAboutYou:
			'Name stomething that would be fun for us to know about you',
		somethingElseYouWouldLikeUsToKnowAboutYou:
			'Something else you would like us to know about you or your background',
		oneThingYouAreProudOf: 'One thing you are proud of :)',
		howDidYouHearAboutUs: 'How did you hear about us?',
		makeSureAllOfYourInformationIsCorrect:
			'Make sure all of your information is correct',
		specialCircumstanceNothingAppliesToMe: 'Nothing applies to me',
		gainWeight: 'Gain weight',
		loseWeight: 'Lose weight',
		increaseEnergy: 'Increase energy levels',
		getStronger: 'Get stronger',
		increaseMuscleMass: 'Increase muscle mass',
		feelBetter: 'Feel better',
		knowMoreAboutNutrition: 'Know more about nutrition',
		betterSleep: 'Get better sleep',
		betterMood: 'Improve my mood',
		getToned: 'Get toned',
		feelBetterAboutMyself: 'Feel better about myself',
		increaseConfidence: 'Increase confidence',
		startExercising: 'Start exercising',
		decreaseInflammationAndPain: 'Reduce inflammation and pain',
		decreaseSugarCraving: 'Reduce my craving for sugar',
		eatAlmostAnything: 'Eat almost anything',
		vegan: 'Vegan',
		dontEatMeat: "Don't eat meat",
		dontEatDairy: "Don't eat dairy products",
		vegetarian: 'Vegetarian',
		breastfeeding: 'Breastfeeding',
		pregnant: 'Pregnant',
		foodAllergies: 'Food allergies',
		hormoneImbalance: 'Hormone imbalance',
		menopause: 'Menopause',
		hadEatingDisorder: 'Have had an eating disorder',
		viaFamilyMember: 'Through a family member',
		viaFriend: 'Through a friend',
		viaCoworker: 'Through a coworker',
		sawAnAd: 'Saw an ad',
		exercise: 'Exercise',

		goalExplanation: 'Explanation of goals',
		job: 'Occupation',
		funToKnow: 'Fun to know',
		somethingElse: 'Other',
		proud: 'Proud',
		food: 'Food',
		situation: 'Situation',
	},
	month: {
		january: 'January',
		february: 'February',
		march: 'March',
		april: 'April',
		may: 'May',
		june: 'June',
		july: 'July',
		august: 'August',
		september: 'September',
		october: 'October',
		november: 'November',
		december: 'December',
	},
	diaryForm: {
		addComment: 'Add a comment',
		aLittle: 'A little',
		hunger: 'Hunger',
		foodQuality: 'Food quality',
		hours: 'hours',
		sleep: 'Sleep',
		energy: 'Energy',
		carbs: 'Carbohydrates',
		protein: 'Protein',
		fat: 'Fat',
		fiber: 'Fiber',
		exercise: 'Exercise',
		submitMacros: 'Submit Macros',
		howAreYouFeelingToday: 'How are you feeling today?',
		waterIntake: 'Water intake',
		tookVitamins: 'Vitamin',

		hungerDescription: 'Did you feel hungry throughout the day?',
		foodQualityDescription: {
			low: 'Low quality',
			medium: 'Medium quality',
			high: 'High quality',
		},

		energyDescription: {
			low: 'Low energy level',
			medium: 'Medium energy level',
			high: 'High energy level',
		},

		exerciseDescription: {
			no: 'No exercise today',
			lowPulse: 'Low pulse exercise',
			highPulse: 'High pulse exercise',
		},

		sleepDescription: 'How many hours did you sleep?',
	},
	measurementForm: {
		weight: 'Weight',
		chest: 'Chest',
		stomach: 'Stomach',
		leftUpperArm: 'Left upper arm',
		rightUpperArm: 'Right upper arm',
		hips: 'Hips',
		leftThigh: 'Left thigh',
		rightThigh: 'Right thigh',
		submitMeasurement: 'Submit measurement',
		kg: 'kg',
		cm: 'cm',
		allMeasurements: 'Measurements summed up',
		uploadFrontPhoto: 'Upload front photo',
		uploadSidePhoto: 'Upload side photo',
	},
	assignmentForm: {
		submitAssignment: 'Submit assignment',
	},
	lowPulse: 'Low-pulse',
	submissionFailed: 'Submission failed',
	mondayAbbreviation: 'M',
	tuesdayAbbreviation: 'T',
	wednesdayAbbreviation: 'W',
	thursdayAbbreviation: 'T',
	fridayAbbreviation: 'F',
	saturdayAbbreviation: 'S',
	sundayAbbreviation: 'S',
	weekSubmissions: 'Week submissions',
	measurement: 'Measurement',
	assignment: 'Assignment',
	notifications: 'Notifications',
	diaryWeekLogs: 'Week logs',
	measurementWeekLogs: 'Week logs',
	change: 'Change',
	nextStep: 'Next',
	continue: 'Continue',
	select: 'Select',
	submit: 'Confirm',
	profile: 'My account',
	macrosWeekLogs: {
		macrosLoggedThisWeek: 'macros skráningar fyrir vikuna',
	},
};

export default namespace;
